module.exports = __webpack_public_path__ + "static/media/file-content.e404e476.svg";